<template>
  <RepeatJobsSelector
    :count="jobFormDataStore.repeatJobsCount"
    :min-count="jobFormDataStore.repeatJobsCountInitialValue"
    :is-repeat-trip="jobFormDataStore.isRepeatTrip"
    :allow-multi-service="allowMultiService"
    @update:count="jobFormDataStore.setRepeatJobsCount"
    @update:isRepeatTrip="jobFormDataStore.setIsRepeatTrip"
  />
</template>

<script setup lang="ts">
import RepeatJobsSelector from './RepeatJobsSelector.vue'
import { useJobFormDataStore } from '../jobs/jobFormDataStore'
import { onUnmounted } from 'vue'

defineProps<{
  allowMultiService: boolean
}>()

const jobFormDataStore = useJobFormDataStore()

onUnmounted(() => {
  jobFormDataStore.setRepeatJobsCount(1)
})
</script>
